/**
 * One row height for every item in the selector's chip cluster.
 *
 * The cluster mixes plain chips, chips that carry the required/optional toggle beside them, and the
 * inline "add emails" placeholder. Without a shared height the wrapper groups set the row height
 * and the plain chips and the placeholder drift off the baseline.
 *
 * The value is the MUI `Chip size="small"` height, so the chips keep the design system's density
 * and only the taller toggle group is brought down to them.
 */
export const CHIP_ROW_HEIGHT = 24;

/** Applied to every chip-and-toggle wrapper group, on both the communications and settings surfaces. */
export const chipGroupSx = { height: `${CHIP_ROW_HEIGHT}px` };
